/**
 * @file dateHelpers.js
 * @description Shared date parsing/formatting helpers for the My Benefits feature. Dates from the API are plain "YYYY-MM-DD" strings without a time component, so they are parsed as local dates (not UTC) to avoid off-by-one-day shifts near midnight.
 */

import { getText } from '../../../i18n';

const INFINITE_YEAR_PREFIX = '9999';
const LOCALE = 'en-US';

export function parseLocalDate(dateStr) {
    if (!dateStr) {
        return null;
    }
    const [y, m, d] = dateStr.split('-');
    return new Date(Number(y), Number(m) - 1, Number(d));
}

export function formatCoverageDate(dateStr) {
    return formatCoverageDateWithFormatter(dateStr, parsed =>
        parsed.toLocaleDateString(LOCALE),
    );
}

export function formatCoverageDateMMDDYYYY(dateStr) {
    return formatCoverageDateWithFormatter(dateStr, parsed => {
        const month = String(parsed.getMonth() + 1).padStart(2, '0');
        const day = String(parsed.getDate()).padStart(2, '0');
        return `${month}-${day}-${parsed.getFullYear()}`;
    });
}

function formatCoverageDateWithFormatter(dateStr, formatter) {
    if (!dateStr) {
        return null;
    }
    if (dateStr.startsWith(INFINITE_YEAR_PREFIX)) {
        return getText('msg_01159980c715');
    }
    const parsed = parseLocalDate(dateStr);
    if (!parsed) {
        return null;
    }
    return formatter(parsed);
}
